import router, { getLaborSwitchOld } from './router';
import store from './store';
import { hasMenuPermission } from '@/utils/checkPermission';
import {
  getNextTabPageNameWithPermission,
  isTabPage,
  hasTabPagePermission,
} from '@/utils/tab-permission';
import { permissionLog } from '@/utils/checkPermission';
import { runLoader } from '../loader';

/*兼容新老rms，后期稳定可以删掉*/
import { getCookie } from '@/utils/cookie';
import { errorReport } from '@/utils/tools';

const isRmsNewVersion = () => {
  let flag = false;
  try {
    let rmsFlagObj: any = {};
    let whs = '';
    //获取仓库
    whs = getCookie('setting_whs_v2') || '';
    if (!whs) {
      return flag;
    }
    //获取localstorage rms-flag
    const rmsFlagStr = localStorage.getItem('rms-flag');
    if (!rmsFlagStr) {
      return flag;
    }
    rmsFlagObj = JSON.parse(rmsFlagStr);
    if (typeof rmsFlagObj[whs] != 'undefined') {
      flag = rmsFlagObj[whs];
    }
    return flag;
  } catch (e) {
    errorReport(e);
    return flag;
  }
};

const rmsDeal = () => {
  try {
    const whs = getCookie('setting_whs_v2') || '';
    if (!whs) {
      return;
    }
    const flag = isRmsNewVersion();

    const newFlag = store.state.warehouseDetail.warehouse.is_rms || false;
    if (flag !== newFlag) {
      const rmsFlagStr: any = localStorage.getItem('rms-flag');
      let rmsFlagObj: any = {};
      if (rmsFlagStr) {
        rmsFlagObj = JSON.parse(rmsFlagStr);
      }
      rmsFlagObj[whs] = newFlag;
      localStorage.setItem('rms-flag', JSON.stringify(rmsFlagObj));
      setTimeout(() => {
        location.reload();
      }, 200);
    }
  } catch (e) {
    errorReport(e);
  }
};
/*兼容新老rms，后期稳定可以删掉*/

// 不重定向白名单
const whiteList = [
  '/login',
  '/google/login',
  '/tob/login',
  '/tob/callback',
  '/forget',
  '/reset',
  '/resetSuccess',
  '/login.html',
  '/login_callback.html',
  '/403',
  '/404',
];

// 声明全局类型扩展
declare global {
  interface Window {
    __LIVE_TIP_NEED_REFRESH__?: boolean;
  }
}

router.beforeEach(async (to, from, next) => {
  if (whiteList.includes(to.path)) {
    next();
  } else {
    // 刷新页面（包括登陆）时，拉取用户信息等
    if (!store.state.user.userInfo.email) {
      try {
        await store.dispatch('getUserInfo');
        const dispatchArr = [
          'loadSystemEnums',
          'loadPermissionMenu',
          'loadUserPermission',
          'loadTabPageNames',
          'loadWarehouseSwitchTime',
          'loadWarehouseDetail',
          'loadTabMenu',
          'loadStaffSwitch',
          'loadShowStoreyTab',
          // 'getOldSystemUrlMap',
        ];
        const taskArr = dispatchArr.map((v) => {
          return store.dispatch(v);
        });
        await Promise.all(taskArr);

        // 🆕 获取门户配置 (包含 Live Tip 白名单)
        // 必须在获取用户信息之后执行,因为需要用户邮箱
        await store.dispatch('loadPortalConfig');

        /*兼容新老rms，后期稳定可以删掉*/
        rmsDeal();
        /*兼容新老rms，后期稳定可以删掉*/

        // 若获取声音失败，不阻塞登录流程
        try {
          await store.dispatch('getNotificationSoundConfigList');
        } catch (e) {
          console.log('error', e);
        }
        // 若获取弱网监测参数失败，不阻塞流程
        try {
          await store.dispatch('loadDisplaySettings');
        } catch (e) {
          console.log('error', e);
        }

        // 获取是否打开全仓盘点
        await store.dispatch('loadOpenFullStockCountSign');
        if (hasMenuPermission(to)) {
          if (isTabPage(to.name) && !hasTabPagePermission(to.name)) {
            next({ name: getNextTabPageNameWithPermission(to.name) });
          } else {
            runLoader();
            getLaborSwitchOld();
            next();
          }
        } else {
          permissionLog(
            store.state.permission.permissionMenu,
            store.state.permission.addRouters,
            to.name as string
          );
          next('/403');
        }
      } catch (e) {
        console.log(e);
        next('/tob/login');
      } finally {
        localStorage.setItem('useremail', store.state.user.userInfo.email);
        localStorage.setItem(
          'stationId',
          store.state.warehouseDetail.warehouse.whs_no
        );
        localStorage.setItem(
          'stationName',
          store.state.warehouseDetail.warehouse.whs_id
        );
      }
    } else {
      if (hasMenuPermission(to)) {
        if (isTabPage(to.name) && !hasTabPagePermission(to.name)) {
          next({ name: getNextTabPageNameWithPermission(to.name) });
        } else {
          next();
        }
      } else {
        permissionLog(
          store.state.permission.permissionMenu,
          store.state.permission.addRouters,
          to.name as string
        );
        next('/403');
      }
    }
  }
});

/**
 * 路由完成后的钩子
 * 🆕 Live Tip 功能: 在路由完成后检查是否需要刷新页面
 *
 * 执行时机说明:
 * 1. router.beforeEach 中获取用户信息和门户配置
 * 2. 如果用户在白名单且 Cookie 不存在,设置 Cookie 和刷新标记
 * 3. router.afterEach 中检测到标记后刷新页面
 * 4. 刷新后 LiveTip 插件读取 Cookie 并显示红框
 */
router.afterEach(() => {
  // 🆕 检查是否需要刷新页面 (用于 Live Tip 功能)
  // 在路由完成后刷新,确保登录态已完全绑定
  if (window.__LIVE_TIP_NEED_REFRESH__) {
    window.__LIVE_TIP_NEED_REFRESH__ = false; // 清除标记,避免重复刷新
    console.log('[LiveTip] Reloading page to activate Live Tip plugin');
    // 延迟一点点,确保当前路由渲染完成
    setTimeout(() => {
      window.location.reload();
    }, 100);
  }
});
